import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Post } from '../../interfaces';

@Component({
  selector: 'edge-articles-main',
  templateUrl: './articles-main.component.html',
  styleUrls: ['../../shared/swiper.scss', './articles-main.component.scss']
})
export class ArticlesMainComponent implements OnInit, OnChanges {
  @Input() newsArticles: Array<Post>;
  filteredArticles: Array<Post>;

  currentArticlesDisplayCount = 6;
  articlesPerLoadCount = 6;
  soccerIcon = '/assets/images/icon-soccer.svg';
  footballIcon = '/assets/images/icon-football.svg';
  generalIcon = '/assets/images/icon-general.svg';
  exerciseIcon = '/assets/images/icon-exercise.svg';
  categoryDropdownOptions = [
    'All',
    'Football',
    'Soccer',
    'Strength and Conditioning'
  ];
  soccerArticles: Array<any>;
  footballArticles: Array<any>;
  exerciseArticles: Array<any>;
  featuredArticles: Array<any>;
  featuredArticleBackgroundImage: string = '';
  selectedCategory: string = '';

  config: object = {
    direction: 'horizontal',
    slidesPerView: 1,
    navigation: true,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      bulletElement: 'span',
      clickable: true
    }
  };

  ngOnInit(): void {
    this.selectedCategory = 'All';
    if (this.newsArticles) {
      this.filteredArticles = this.newsArticles;

      this.featuredArticles = this.newsArticles.filter((article: any) => {
        return article.categories.indexOf('featured') >= 0;
      });

      this.soccerArticles = this.newsArticles.filter((article: any) => {
        return article.categories.indexOf('soccer') >= 0;
      });

      this.footballArticles = this.newsArticles.filter((article: any) => {
        return article.categories.indexOf('football') >= 0;
      });

      this.exerciseArticles = this.newsArticles.filter((article: any) => {
        return article.categories.indexOf('strength and conditioning') >= 0;
      });
    }
  }

  ngOnChanges(): void {
    this.filteredArticles = this.newsArticles;
  }

  filterArticlesByCategory(): void {
    this.currentArticlesDisplayCount = this.articlesPerLoadCount;
    if (this.selectedCategory === 'All') {
      this.filteredArticles = this.newsArticles;
    } else if (this.selectedCategory === 'Football') {
      this.filteredArticles = this.footballArticles;
    } else if (this.selectedCategory === 'Soccer') {
      this.filteredArticles = this.soccerArticles;
    } else if (this.selectedCategory === 'Strength and Conditioning') {
      this.filteredArticles = this.exerciseArticles;
    }
  }

  getArticleCategoryName(article: any): string {
    return article.categories[0];
  }

  getArticleCategoryIcon(article: any): string {
    if (article.categories.indexOf('football') >= 0) {
      return this.footballIcon;
    } else if (article.categories.indexOf('soccer') >= 0) {
      return this.soccerIcon;
    } else if (article.categories.indexOf('strength and conditioning') >= 0) {
      return this.exerciseIcon;
    } else {
      return this.generalIcon;
    }
  }

  getFeaturedArticleBackgroundImage(article: Post): string {
    if (article.featuredImageUrl.length > 0) {
      return (this.featuredArticleBackgroundImage = article.featuredImageUrl);
    } else {
      return (this.featuredArticleBackgroundImage = '');
    }
  }

  loadMoreArticles(): void {
    this.currentArticlesDisplayCount += this.articlesPerLoadCount;
  }
}
